export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BoletaPage.vue?vue&type=template&id=2b7eac48&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/BoletaPage.vue?vue&type=template&id=2b7eac48&scoped=true&
// module id = 598
// module chunks = 28